import { render, staticRenderFns } from "./SafetyObservationCategoryEdit.vue?vue&type=template&id=1b910362&"
import script from "./SafetyObservationCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports